<template>
  <v-container fluid>
    <!-- Filtros -->
    <v-row dense>
      <v-col class="d-flex" cols="12" sm="3">
        <v-select v-model="semestre" hide-details @change="selectSemestre" :items="semestres"
          label="Filtre por Semestre" item-value="Id" item-text="Nombre" return-object dense />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field v-model="filters.grupo" label="Filtrar por Grupo" outlined dense hide-details
          class="text-sm"></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field v-model="filters.asignatura" label="Filtrar por Asignatura" outlined dense
          hide-details></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field v-model="filters.docente" label="Filtrar por Docente" outlined dense hide-details></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn :loading="lgExcel" color="green" dark @click="descargarExcel">
          <v-icon left>mdi-download</v-icon>
          Planificación
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-data-table :headers="headers" :items="filteredData" item-value="Id" class="elevation-1" :items-per-page="100"
      item-key="Id" @click:row="onRowClick">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Comisiones Planificadas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color='primary' small @click='agregarComision'>Agregar Comision a planificar</v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.Horario="{ item }">
        <div @click.stop="startEdit(item)" style="cursor: pointer;" >

          <v-select v-if="isEditing(item)" :items="HorariosSemi" item-text="label" item-value="value"
            v-model="editing[item.Id].value" dense hide-details style="width: 60px" @change="saveHorario(item)"
            @blur="finishEdit(item)" />

          <span v-else>
            {{ item.Horario ? formatHorario(item.Horario) : '—' }}
          </span>

        </div>
      </template>

      <template v-slot:item.Faltante="{ item }">
        <v-chip :color="item.Faltante > 0 ? 'red' : 'green'" dark small>
          {{ item.Faltante }}
        </v-chip>
      </template>
      <template v-slot:item.NoLaboral="{ item }">
        <v-chip v-if="item.NoLaboral == 1" color="orange" outlined dark small>
          NL
        </v-chip>
      </template>
      <template v-slot:item.Fecha_Inicio="{ item }">
        {{ formatDate(item.Fecha_Inicio) }}
      </template>

      <template v-slot:item.Acciones="{ item }">
        <v-col class="d-flex justify-space-between">
          <v-icon color="purple" class="mr-2" @click.stop="agregarDia(item)">
            mdi-calendar-check
          </v-icon>
          <v-icon color="primary" class="mr-2" @click.stop="editar(item)">
            mdi-pencil
          </v-icon>
          <v-icon color="red" class="mr-2" @click.stop="eliminar(item)">
            mdi-delete
          </v-icon>
        </v-col>
      </template>
    </v-data-table>
    <!-- Dialogo pantalla completa detallle Docente -->
    <v-dialog v-model="dialog" fullscreen v-if="details" persistent>
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Detalles de Comisión</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid class="overflow-container" style="height:calc(100vh - 90px);">
            <v-row>
              <v-col cols="4" v-for="(item, index) in modalidad" :key="index">
                <strong>{{ item == 'DIST' ? 'Distancia' : 'Semipresencial' }}</strong>
                <v-list style="height:calc(100vh - 160px); overflow-y: auto;">
                  <v-list-item
                    v-for="comision in details.Comisiones.filter((comision) => { return comision.NombreComision.includes(item); })"
                    :key="comision.NombreComision">
                    <v-list-item-content>

                      <v-checkbox hide-details v-model="chkComisionId" :value="comision.ComisionPlanificacionId">
                        <template v-slot:label>
                          <v-list-item-title primary>
                            {{ comision.NombreComision }}
                          </v-list-item-title>
                        </template>
                      </v-checkbox>

                      <v-list-item-subtitle>
                        {{ comision.Asignatura }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <v-chip color="orange" dark x-small v-if="comision.fusion" outlined>
                          {{ comision.fusion }}
                        </v-chip>
                        <v-chip color="blue" dark x-small v-if="comision.Horario" outlined>
                          {{ comision.Horario }}
                        </v-chip>
                      </v-list-item-subtitle>

                      <v-list-item-subtitle>
                        <strong>Tutorías:</strong>
                        <v-chip color="green" dark x-small outlined>
                          {{ comision.Ponderacion }}
                        </v-chip>
                        <v-chip :color="comision.Faltante > 0 ? 'red' : 'green'" v-if="comision.Faltante != 0" dark
                          x-small outlined>
                          {{ comision.Faltante }}
                        </v-chip>
                        <ul>
                          <li v-for="tutoria in comision.tutorias" :key="tutoria.fecha">
                            {{ formatTutoriaDate(tutoria.fecha) }}
                            <v-chip color="blue" v-if="tutoria.MismoDia" dark x-small outlined>
                              Super.
                            </v-chip>
                            <v-icon color="red" class="mr-2" x-small
                              @click.stop="eliminarTuto(comision, tutoria.tutoriaId, tutoria.fecha)" title="Eliminar">
                              mdi-delete
                            </v-icon>
                            <v-chip color="orange" v-if="tutoria.NoLaboral" dark x-small outlined
                              @click.stop="eliminarTuto(comision, tutoria.tutoriaId, tutoria.fecha)">
                              NL - Eliminar?
                            </v-chip>

                          </li>
                        </ul>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>

              <v-col cols="4">
                <v-row>
                  <strong>Disponibilidad Docente</strong>
                  <v-spacer></v-spacer>
                  <v-btn color="success" x-small @click="dgDisponibilidad = true">Agregar</v-btn>
                </v-row>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Dia</th>
                        <th class="text-left">Horario</th>
                        <th class="text-left">Modalidad</th>
                        <th class="text-left">Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in details.Disponibilidad" :key="index">
                        <td>{{ item.dia }}</td>
                        <td>{{ item.hora }}</td>
                        <td>{{ item.Modalidad }}</td>
                        <td>
                          <v-chip :color="item.Libre ? 'blue' : 'orange'" dark x-small outlined
                            @click.stop="planificarAqui(item.disponibilidadId)" :loading="loadingDispo">
                            {{ item.Libre ? "Planificar aquí!" : "Replanificar" }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dgDisponibilidad" scrollable max-width="500px" transition="dialog-transition">
      <v-card>
        <v-card-title>Cargar disponibilidad</v-card-title>
        <v-card-text>
          <VDisponibilidad ref="dispo"></VDisponibilidad>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="dgDisponibilidad = false">Cerrar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cargarDisponibilidad" :loading="loadingDispo">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dgPlaniDiaria" persistent fullscreen v-if="dgPlaniDiaria" hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-btn icon @click="dgPlaniDiaria = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Planificacion diaria</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dgPlaniDiaria = false">Cerrar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid class="overflow-container" style="height:calc(100vh - 90px);">
            <PlaniDiaria v-if="dgPlaniDiaria" :comision="comision"></PlaniDiaria>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <EditarPlani :comisionData="comisionEdit" :dialog="dgEditar" v-if="dgEditar" @actualizado="comisionesActualizadas">
    </EditarPlani>
    <ConfimaDialog ref="confirmaDialog" />
  </v-container>

</template>

<script>
import Planificador from "../../services/Planificador.service";
import VDisponibilidad from "../../components/planificacdor/Disponifilidad.vue"
import PlaniDiaria from "../../components/planificacdor/PlanificacionDiaria.vue"
import EditarPlani from "../../components/planificacdor/ComisionPlanificacionEditor.vue"
import ConfimaDialog from "../../components/shared/ConfirmDialog.vue";
export default {
  components: {
    VDisponibilidad,
    PlaniDiaria,
    EditarPlani,
    ConfimaDialog
  },
  data() {
    return {
      editingId: null,
      tempHorario: null,
      editing: {},
      HorariosSemi: [
        { label: '15:00', value: '15:00' },
        { label: '19:00', value: '19:00' }
      ],
      dgEditar: false,
      lgExcel: false,
      dgPlaniDiaria: false,
      comision: null,
      comisionEdit: null,
      dgDisponibilidad: false,
      loadingDispo: false,
      chkComisionId: null,
      dialog: false,
      details: null,
      semestre: null,
      semestres: this.$store.semestres,
      modalidad: ['DIST', 'SEMI'],
      headers: [
        { text: "Id", value: "Id" },
        { text: "Año", value: "Año" },
        { text: "Grupo", value: "Grupo" },
        { text: "Modal.", value: "Modalidad" },
        { text: "Asignatura", value: "Asignatura" },
        { text: "Docente", value: "Docente" },
        { text: "Fusion", value: "Fusion" },
        { text: "Horario", value: "Horario" },
        { text: "Fecha Inicio", value: "Fecha_Inicio" },
        { text: "Ponderacion", value: "Ponderacion" },
        { text: "Faltante", value: "Faltante" },
        { text: "NoLaboral", value: "NoLaboral" },
        { text: "Acciones", value: 'Acciones', sortable: false },
      ],
      items: [],
      filters: {
        grupo: "",
        asignatura: "",
        docente: "",
      },
    };
  },

  computed: {
    filteredData() {
      return this.items.filter((item) => {
        const grupoMatch = item.Grupo.toLowerCase().includes(
          this.filters.grupo.toLowerCase()
        );
        const asignaturaMatch = item.Asignatura.toLowerCase().includes(
          this.filters.asignatura.toLowerCase()
        );
        const docenteMatch = item.Docente.toLowerCase().includes(
          this.filters.docente.toLowerCase()
        );
        return grupoMatch && asignaturaMatch && docenteMatch;
      });
    },
  },
  methods: {
    startEdit(item) {
      if (item.Modalidad !== 'S') return

      // Si la fila no tiene estado, lo crea
      this.$set(this.editing, item.Id, {
        editing: true,
        value: item.Horario || null
      })
    },
    isEditing(item) {
      return this.editing[item.Id]?.editing === true
    },

    async saveHorario(item) {
      const seleccion = this.editing[item.Id].value

      // actualizar tabla
      item.Horario = seleccion

      this.finishEdit(item)
    },
    finishEdit(item) {
      this.$set(this.editing[item.Id], 'editing', false)
    },

    selectSemestre() {
      this.fetchData();
    },
    async eliminarTuto(comision, tutoriaId, Fecha) {

      const confirmado = await this.$refs.confirmaDialog.open({
        title: 'Confirmar Eliminación',
        message: `¿Estás seguro de que deseas eliminar la tutoria del <br><b>${this.formatTutoriaDate(Fecha)}</b> <br>de la asignatura <b>"${comision.Asignatura}</b>"? `,
      });

      if (confirmado) {
        Planificador.BorrarTutoria(comision.ComisionPlanificacionId, tutoriaId, Fecha.split("T")[0]).then(async (result) => {
          Planificador.ObtenerDetalle(comision.ComisionPlanificacionId).then((result2) => {
            this.details = result2.data;
            this.$toast.success("Tutoria eliminada");
            this.fetchData();
          }).catch((err) => {
          });;
        })
      }
    },
    async descargarExcel() {

      let ids = { comisprint: this.filteredData.map(obj => obj.Id) };
      this.lgExcel = true; // Activar el indicador de carga
      Planificador.DescargarPlanificacionPost(ids).then((result) => {
        try {
          // Crear un enlace para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement("a");
          link.href = url;
          // Definir el nombre del archivo
          link.setAttribute("download", "ReportePlanificacion.xlsx");
          // Agregar el enlace al DOM y hacer clic en él
          document.body.appendChild(link);
          link.click();
          // Limpiar el enlace del DOM
          link.remove();
          this.lgExcel = false; // Desactivar el indicador de carga
        } catch (error) {
          this.$toast.error("Error al descargar el archivo Excel");
        }
      }).catch((err) => {
        this.$toast.error("Error al descargar el archivo Excel");
        this.lgExcel = false; // Desactivar el indicador de carga
      });
    },
    agregarDia(item) {
      this.comision = item;
      this.dgPlaniDiaria = true;
    },
    agregarComision() {
      this.comisionEdit = {},
        this.dgEditar = true;
    },
    editar(comi) {
      Planificador.EditarComiPlani(comi.Id).then(
        res => {
          this.comisionEdit = { ...res.data.cp };
          this.comisionEdit.horario = res.data.strHora;
          this.dgEditar = true;
        }).catch(err => {
          this.$toast.error(err.response.data);
          this.dgEditar = false;
        });

    },
    eliminar(comi) {
      Planificador.EliminarComiPlani(comi.Id).then(
        res => {
          this.items = this.items.filter(obj => obj.Id !== comi.Id);
          this.$toast.warning(res.data);
        }).catch(err => {
          this.$toast.error(err.response.data);
          this.dgEditar = false;
        });

    },
    async comisionesActualizadas(actualiza) {
      this.comisionEdit = {};
      if (actualiza)
        await this.fetchData();
      this.dgEditar = false;
    },
    async cargarDisponibilidad() {
      if (!this.$refs.dispo.dia || !this.$refs.dispo.horario || this.$refs.modalidad) {
        return;
      }
      this.loadingDispo = true;
      let dia = { ...this.$refs.dispo.dia };
      dia.horario = this.$refs.dispo.horario;
      dia.docenteId = this.details.DocenteId;
      dia.modalidad = this.$refs.dispo.modalidad.modalidad;
      let disponibilidad = dia;
      Planificador.AgregarDisponibilidad(disponibilidad).then(
        res => {
          this.loadingDispo = false;
          this.$refs.dispo.dia = null;
          this.$refs.dispo.horario = null;
          this.$refs.dispo.modalidad = null;
          this.details.Disponibilidad = res.data;
          this.$toast.success("Registro cargado.");
        }).catch(err => {
          this.loadingDispo = false;
          this.$toast.error(err.response.data);
        });
    },
    planificarAqui(disponibilidadId) {
      if (!this.chkComisionId) {
        this.$toast.error("Seleccione una Comision");
        return;
      }
      Planificador.PlanificaiconParcial(this.chkComisionId, disponibilidadId).then(async (result) => {
        const response = await Planificador.ObtenerDetalle(this.chkComisionId);
        this.details = response.data;
        this.chkComisionId = null;
      }).catch((err) => {
        console.log(err);
        this.$toast.error(err.response.data);
      });
    },
    async onRowClick(item) {
      try {
        const response = await Planificador.ObtenerDetalle(item.Id);
        this.details = response.data;
        this.dialog = true; // Mostrar diálogo
      } catch (error) {
        console.error("Error al obtener los detalles:", error);
      }
    },
    async fetchData() {
      try {
        this.items = [];
        const response = await Planificador.ObtenerNumerica(this.semestre.Id);
        const data = await response.data;
        this.items = data;
      } catch (error) {
        this.$toast.error(error)
      }
    },
    formatHorario(horario) {
      if (!horario) return "";
      return horario; // Extrae solo HH:mm
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const formatter = new Intl.DateTimeFormat("es-ES", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
      try {
        return formatter.format(date);

      } catch (error) {
        return '';
      }
    },
    formatTutoriaDate(fecha) {
      const date = new Date(fecha);
      const options = {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      };
      return date.toLocaleDateString("es-ES", options);
    },
  },
  mounted() {
    //this.fetchData();

  },
};
</script>

<style scoped>
.v-chip {
  font-size: 0.9em;
}
</style>